import {NgModule} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {UiModule} from "@fedelta-pos/ui";
import {RouterModule} from "@angular/router";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {DateInputsModule} from "@progress/kendo-angular-dateinputs";

/**
 * The Shared Module is a convenience module which saves declaring reusable components into other modules.
 * The Shared Module may be imported into all other Modules as required to gain access to shared reusable components.
 *
 * The components declared in the Shared Module should be generic in nature and truly reusable.
 *
 * See https://angular.io/guide/ngmodule#shared-modules
 */
@NgModule({
    imports: [
        CommonModule,
        UiModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserAnimationsModule,
        TranslateModule,
        DateInputsModule
    ],
    declarations: [
    ],
    exports: [
        BrowserAnimationsModule,
        CommonModule,
        TranslateModule,
        UiModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        DateInputsModule
    ]
})
export class SharedModule {
}
